export default{
    portalUrl:"https://promineo-portal.promineo.no/api/",
    portalReadTokenUrl:"https://promineo-portal.promineo.no/api/azureadtoken"
}